import { Nullable } from '@ygoargentina/sdk/api/api.types';
import { get, set, del } from 'idb-keyval';
import { StateStorage } from 'zustand/middleware';

export const customStorage: StateStorage = {
  getItem: async (name: string): Promise<Nullable<string>> => {
    return (await get(name)) || null;
  },
  setItem: async (name: string, value: string): Promise<void> => {
    await set(name, value);
  },
  removeItem: async (name: string): Promise<void> => {
    await del(name);
  },
};
